export class UtilityAccount {
    constructor(bus_segment_id?: string, utility_account_id?: string, util_account_descr?: string) {
        this.bus_segment_id = bus_segment_id;
        this.utility_account_id = utility_account_id;
        this.util_account_descr = util_account_descr;
    }

    bus_segment_id: string;
    utility_account_id: string;
    util_account_descr: string;
}